export default __webpack_public_path__ + "static/media/lookingGlass.fd289255.svg";